import numeral from "numeral";

export default [
    {
      label: 'Part Number',
      field: 'part_number',
      type: 'text',
    },
    {
      label: 'Quotes',
      field: 'quotes',
      type: 'number',
    },
    {
      label: 'Quantity',
      field: 'quantity',
      type: 'number',
    },
    {
      label: 'Dollars',
      field: 'dollars',
      type: 'number',
      formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')}
    },
]